import { Grid, makeStyles } from '@material-ui/core';
import Breadcrumbs, { BreadcrumbsFields } from 'components/Breadcrumbs';
import PageTitle from 'components/PageTitle';
import {
  cleanEnvironmentRequest,
  getEnvironmentRequest,
} from 'modules/environments/actions';
import {
  EnvironmentFields,
  ProviderResourcesProps,
} from 'modules/environments/interfaces';
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import NavBarEnvironments from '../../NavBarEnvironments';
import styles from './styles';

const useStyles = makeStyles(styles);

interface TemplateProps {
  currentPage?:
    | 'instances'
    | 'servers'
    | 'configuration'
    | 'history'
    | 'maintenance'
    | 'image';
  titlePage?: string;
  breadcrumbs?: BreadcrumbsFields[];
  titleContent?: string;
  subtitleContent?: string;
  actionsContent?: React.ReactNode;
  actionsHeader?: React.ReactNode;
  children?: React.ReactNode;
  environment: EnvironmentFields | null;
  providerResources: ProviderResourcesProps;
  getEnvironmentRequest: (props: { id: string; skipProvider: boolean }) => void;
  cleanEnvironmentRequest: () => void;
  hiddenClick?: () => void;
}

const EnvironmentsTemplate = ({
  currentPage,
  titlePage,
  breadcrumbs,
  titleContent,
  subtitleContent,
  actionsContent,
  children,
  environment,
  actionsHeader,
  providerResources,
  getEnvironmentRequest,
  cleanEnvironmentRequest,
  hiddenClick,
}: TemplateProps) => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const requiredRefresh =
    currentPage && ['configuration', 'maintenance'].includes(currentPage);

  React.useEffect(() => {
    if (!id) {
      cleanEnvironmentRequest();
      return;
    }

    if (environment?.environment_uuid !== id || requiredRefresh) {
      getEnvironmentRequest({
        id,
        skipProvider: providerResources.environment_uuid === id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container xs={12} direction="column">
      <Grid container justify="space-between">
        {titlePage && (
          <PageTitle
            title={titlePage}
            subtitle={breadcrumbs ? <Breadcrumbs values={breadcrumbs} /> : ''}
          />
        )}
        {actionsHeader}
      </Grid>
      {currentPage && (
        <NavBarEnvironments environment={environment} current={currentPage} />
      )}

      <Grid
        className={classes.sectionContent}
        style={{ marginTop: titlePage ? 60 : 0 }}
      >
        <Grid container justify="space-between" onClick={hiddenClick}>
          <PageTitle title={titleContent || ''} subtitle={subtitleContent} />
          {actionsContent}
        </Grid>

        {children}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentSelected, providerResources },
}: ApplicationState) => ({
  environment: environmentSelected,
  providerResources,
});

export default connect(mapStateToProps, {
  getEnvironmentRequest,
  cleanEnvironmentRequest,
})(memo(EnvironmentsTemplate));
